import React from 'react';
import ConnectingNeedsPlatform from './components/ConnectingNeedsPlatform';

function App() {
  return <ConnectingNeedsPlatform />;
}

export default App;